import React from "react";
import {useIntl} from 'react-intl';

function ScheduleCard(props) {
    const intl = useIntl();
    const dayOfWeek = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1; // because in Javascript Sunday is 0 and in the array from weekOpenSchedule Sunday is 6
    if (!props.scheduleData || props.scheduleData.length === 0) {
        return <></>
    }


    return (

        <section className="schedule-card">
            <header
                className={props.scheduleData[dayOfWeek].isOpen ? "schedule-card-header success" : "schedule-card-header danger"}>
                {props.title}
                <div className="status-label ml-auto">
                    {props.scheduleData[dayOfWeek].isOpen ?
                    intl.formatMessage({id: 'ShopScheduleOpen'}).toUpperCase()

                    :
                    intl.formatMessage({id: 'ShopScheduleClosed'}).toUpperCase()

                    }
                </div>
            </header>
            <div className="card-content">
                {
                    props.scheduleData.map((day, index) => (
                        <div key={index + day} className="day-row">
                            <div className="row">
                                <span className="day-name">{day.dayName}</span>
                                <span className="day-status">
                                            {day.isOpen ?
                                                <span className="open">{
                                                    intl.formatMessage({id: 'ShopScheduleOpen'}).toUpperCase()
                                                }</span>
                                                : <span className="closed">
                                                   {intl.formatMessage({id: 'ShopScheduleClosed'}).toUpperCase()}
                                                </span>
                                            }
                                        </span>

                                <span className="day-schedules">
                                    {day.daySchedule.map((schedule, index) => (
                                        <React.Fragment key={index}>
                                            {schedule.openFrom} - {schedule.openUntil}
                                            {day.daySchedule.length > 1 && index !== day.daySchedule.length - 1 &&
                                            <br/>}
                                        </React.Fragment>
                                    ))}
                                        </span>
                            </div>
                        </div>
                    ))
                }
            </div>
        </section>

    );

}


export default ScheduleCard;
